/**
 * Customer-side roles that may open the DATEXT billing linkout — mirrors the roles the backend
 * authorizes on the linkout endpoint (`AbrechnungRollenAusdruecke.LINKOUT_ROLES_EXPRESSION`; keep
 * both in sync when either changes). UX-only gate; the server remains the binding enforcement.
 */
export const DATEXT_CUSTOMER_LINKOUT_ROLES: readonly string[] = [
  'PRACTICE_CEO',
  'PRACTICE_LEAD',
  'CUSTOMER_LAB_CEO',
  'CUSTOMER_LAB_LEAD',
];
